const SocialMedia = {
  INSTAGRAM_HANDLE: '@SlimmingWorld',
  INSTAGRAM_HASH_TAG: '#SlimmingWorld',
};

export default SocialMedia;
